import React from 'react';
import { AwardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { SectionHeading } from './ui/SectionHeading';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 border-t border-primary/20 bg-surface py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-138" data-mp="1j9qpghfdfsh6">
      <div className="mx-auto max-w-3xl px-4" data-id="element-139" data-mp="1ncwrtdzd4zid">
        <SectionHeading id="pricing-title" data-id="element-140" data-mp="1s8u5tdn5ltrz">Choose Your Option</SectionHeading>

        <article className="mt-10 overflow-hidden rounded-3xl border-2 border-primary bg-background shadow-glow-strong" data-id="element-141" data-mp="1x8zv4n5yb46w">
          <div className="border-b border-primary/30 bg-surface-hover px-6 py-4 sm:px-10" data-id="element-142" data-mp="226ruu3cu7uln">
            <span className="inline-flex items-center gap-2 rounded-full bg-cta px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.14em] text-cta-foreground" data-id="element-143" data-mp="2vh13nb4q3qc">
              <AwardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-144" data-mp="1mgofdd5lddle" /> Main Offer
            </span>
          </div>
          <div className="p-6 sm:p-10" data-id="element-145" data-mp="1hpg4ecom5k64">
            <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-146" data-mp="1hodfgaauprsu">
              <div data-id="element-147" data-mp="1crmwnf7nwi3q">
                <h3 className="text-2xl font-bold leading-tight tracking-tight text-foreground sm:text-3xl" data-id="element-148" data-mp="1cosfbwjy3dej">{productShortName}</h3>
                <p className="mt-2 text-sm text-muted" data-id="element-149" data-mp="25fagut50t6pu">
                  All {totalVolumes} volumes + {totalBonuses} exclusive bonuses
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-150" data-mp="20ed2krn4swtm">
                <span className="text-sm text-muted" data-id="element-151" data-mp="1vgbic3dyyrgk">
                  Regular price: <span className="line-through decoration-primary decoration-2" data-id="element-152" data-mp="1rg1a0k2pfoyj">{priceBefore}</span>
                </span>
                <p className="mt-2 text-xs font-bold uppercase tracking-[.14em] text-primary" data-id="element-153" data-mp="k390l504vvut">Today:</p>
                <p className="mt-1 whitespace-nowrap text-5xl font-extrabold leading-none tracking-tight text-cta sm:text-6xl" data-id="element-154" data-mp="fzjd6iv73kbd">{price}</p>
              </div>
            </div>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-155" data-mp="mhe6v95q8hx0">
              Get my professional edition now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-156" data-mp="cioo7e60atfp">
              <span className="inline-flex items-center gap-1.5" data-id="element-157" data-mp="3uwxthpbw7233">
                <LockIcon className="h-4 w-4 text-primary" aria-hidden="true" data-id="element-158" data-mp="3uul5ovjgdxi4" /> Secure payment
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-159" data-mp="3kyi53u4926xa">
                <ZapIcon className="h-4 w-4 text-primary" aria-hidden="true" data-id="element-160" data-mp="3l0bcxcqlmx6v" /> Instant access
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-161" data-mp="3pvgy29c6g7tw">
                <ShieldCheckIcon className="h-4 w-4 text-primary" aria-hidden="true" data-id="element-162" data-mp="3bz3fewvwq0du" /> 7-day guarantee
              </span>
            </div>
          </div>
        </article>
      </div>
    </section>;
}